import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from "./components/Login";
import EntryPage from "./components/EntryPage";
import MapPage from "./components/MapPage";
import FaultEntry from "./components/FaultEntry";

import { auth } from "./components/firebase"; 

function App() {
  const [appState, setAppState] = useState(null);
  const [faultData, setFaultData] = useState(null);
  const [faultDate, setFaultDate] = useState(null);

  const[currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });

    return () => unsubscribe();
  }, []);

  const handleStart = (data) => {
    setAppState({ page: "map", ...data });
  };

  const handleFaultEntry = (date, faults = []) => {
    setAppState({ page: "fault", faultDate: date });
    setFaultDate(date);
    setFaultData(faults);
  };

  return (
    <Router>
      <Routes>
        {/* Authentication Check */}
        <Route
          path="/"
          element={currentUser ? <Navigate to="/entry" /> : <Navigate to="/login" />}
        />

        {/* Login Page */}
        <Route
          path="/login"
          element={<Login onLogin={(user) => setCurrentUser(user)} />}
        />

        {/* Entry Page */}
        <Route
          path="/entry"
          element={
            currentUser ? (
              <EntryPage onStart={handleStart} onFaultEntry={handleFaultEntry} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Map Page */}
        <Route
          path="/map"
          element={
            currentUser && appState?.page === "map" ? (
              <MapPage
                lat={appState.lat}
                lng={appState.lng}
                geoJson={appState.geoJson}
              />
            ) : (
              <Navigate to="/entry" />
            )
          }
        />

        {/* Fault Entry Page */}
        <Route
          path="/fault-entry"
          element={
            currentUser && appState?.page === "fault" ? (
              <FaultEntry
                geoJson={{}}
                faultDate={faultDate}
                faultData={faultData}
              />
            ) : (
              <Navigate to="/entry" />
            )
          }
        />

        {/* Catch-all Route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;